/*
 * File: ClinicalPreferenceValue.ts
 * Project: mp-mobile-app
 *
 * Created by Cole on 06/14/2021
 *
 * Copyright (c) 2021 MacPractice, Inc. All rights reserved.
 *
 * Description: Models the clinical widget preference returned from the API.
 */
import { types } from "mobx-state-tree";

const ClinicalPreferenceValueProperties = types.model(
  "ClinicalPreferenceValue",
  {
    key: types.string,
    title: types.string,
    tableType: types.number,
    flagTreatment: types.boolean,
    color: types.string,
    orderNumber: types.number,
    columnNumber: types.number,
    showInView: types.boolean
  }
);

export const ClinicalPreferenceValue = ClinicalPreferenceValueProperties.actions(
  self => ({
    toggleShowInView() {
      self.showInView = !self.showInView;
    },
    setOrder(order: number) {
      self.orderNumber = order;
    },
    setColumn(column: number) {
      self.columnNumber = column;
    }
  })
);
